import Callout from "ds/components/Callout";
import { Spinner } from "components/Spinner";

const DeploymentProgressCallout = () => {
  return (
    <Callout variant="info" title="Processing deployment" icon={Spinner}>
      Your deployment is currently being processed. This may take a few moments.
    </Callout>
  );
};

export default DeploymentProgressCallout;
